import { FormControl, Grid, InputLabel, MenuItem, Select, Skeleton } from '@mui/material';
import { RelationType } from '@thro-types/access-handler';

import { t } from 'i18next';
import { useState } from 'react';

import { useEntitlementGroupsQuery } from 'api/hooks/accessHandler/entitlementGroup';
import DetailPage from 'app/components/DetailPage';
import Subheading from 'app/components/DetailPage/components/Subheading';
import { translations } from 'locales/i18n';
import { useAuthContext } from 'utils/hooks/useAuthContext';

import { isLeihBarAdmin } from '../helper';
import { Vacation } from './Vacation';
import { LenderTimes } from './components/LenderTimes';
import { ToLeihbarButton } from './components/ToLeihbarButton';

interface OpeningHoursProps {
  lenderGroupId: number;
}

export const OpeningHours = ({ lenderGroupId }: OpeningHoursProps) => {
  const { permissions } = useAuthContext();
  const { data: entitlementGroups, isLoading } = useEntitlementGroupsQuery(
    isLeihBarAdmin(permissions),
    {
      params: { relationType: RelationType.LEIHBAR }
    }
  );
  const [lenderGroupIdState, setLenderGroupIdState] = useState(lenderGroupId);
  return (
    <Grid container gap={2}>
      {isLeihBarAdmin(permissions) &&
        (isLoading || !entitlementGroups ? (
          <Skeleton width={190} height={40} sx={{ transform: 'unset' }} />
        ) : (
          <Grid item xs={4}>
            <FormControl>
              <InputLabel>{t(translations.pages.leihbar.daily.lenderGroup())}</InputLabel>
              <Select
                fullWidth
                size="small"
                value={entitlementGroups.data.find(ent => ent.id === lenderGroupIdState)?.id}
                label={t(translations.pages.leihbar.daily.lenderGroup())}
                onChange={e => {
                  if (e.target.value && typeof e.target.value === 'number')
                    setLenderGroupIdState(e.target.value);
                }}
              >
                {entitlementGroups.data.map(eG => (
                  <MenuItem key={eG.id} value={eG.id}>
                    {eG.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        ))}
      <Grid container item xs justifyContent={'flex-end'}>
        <ToLeihbarButton />
      </Grid>
      <LenderTimes lenderGroupId={lenderGroupIdState} />
      <DetailPage>
        <Grid container>
          <Subheading
            content={t(translations.pages.leihbarOpeningHoursSettings.vacation.vacationTimes())}
          />
        </Grid>
        <Vacation lenderGroupId={lenderGroupIdState} />
      </DetailPage>
    </Grid>
  );
};
